import React from "react";
import { AiFillDelete } from "react-icons/ai";
import PropTypes from "prop-types";

export default function BDeleteButton({ onDelete, btnText = "Löschen" }) {
  return (
    <button
      onClick={onDelete}
      className="py-1 px-3 rounded-md shadow-md bg-red-600 text-white flex items-center cursor-pointer hover:bg-red-500 transition-all focus:shadow-outline focus:outline-none"
      type="submit"
    >
      <AiFillDelete className="mr-1" />
      {btnText}
    </button>
  );
}

BDeleteButton.propTypes = {
  onDelete: PropTypes.func.isRequired,
  btnText: PropTypes.string,
};
